define([
    'edge/platform/tracking/pageViews',
    'edge/platform/tracking/EventHubProvider',
    'edge/platform/tracking/CredentialsProvider',
    '../featuredetection/ApplicationFeatures'
], (pageViews,
    eventHubProviderFactory,
    CredentialsProvider,
    ApplicationFeatures) => {
    return angular.module('edge.platform.tracking', [])
        .constant('applicationFeatures', ApplicationFeatures.getAllFeatures())
        .provider('EventHub', eventHubProviderFactory())
        .provider('Credentials', CredentialsProvider)
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/tracking/module.js